/* eslint max-len: 0 */
import {
    PaymentTypesRepository,
    RecommendationsRepository,
    AppIntegrationsRepository,
    ActivationCodesRepository,
    TransactionsRepository,
    DevicesRepository,
    LicensesRepository,
    AppPricesRepository,
} from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import eventManager from 'common/services/-RFC.eventManager';

/**
 * One Click Payment controller
 * Handles ocp payment calls
 */

angular.module('controllers')
    .controller(
        'OneClickPayment',
        (
            $scope, Util, ActivationCodeRestService, LicenseRestService,
            PaymentsRestService, $filter, RecommendationsRestService, TransactionRestService, $rootScope, DeployRestService, $state,
        ) => {

            $rootScope.disableCloseModalOCP = true;
            $scope.showOcpScreen = false;

            /* this variable is used to delay the second OCP
            banner in case he already purchased one product.
            E.g: user buys ISEC and after the payment is completed, we show Prime offer immediately */
            $rootScope.hideSecondOfferUntilRefresh = false;

            // feature/OE-7610-a-b-test-aia-banner-copy-ocp
            // if ($state.params.resourceId === 'adwp1') {

            const recommendations = RecommendationsRepository.getAll();

            $scope.recommendation = recommendations.find(recommendation => recommendation.attributes.acronym === $state.params.resourceId);

            // } else {

            //     [$scope.recommendation] = RecommendationsRepository.getAll();

            // }
            // feature/OE-7610-a-b-test-aia-banner-copy-ocp

            const [onMergingActivationCode] = ActivationCodesRepository.getAll();
            const [currentLicense] = LicensesRepository.getAll();
            const modifyDate = new Date(Util.deepFind(currentLicense, 'attributes.modify_date'));

            $scope.submitted = false;
            // CMA Links
            const currentLanguage = CWCONFIG.language;

            $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
            $scope.renewalPrices = CWCONFIG.cma.subscriptions.renewalPrices;
            $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
            $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
            $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
            $scope.cancellation = `${CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage)}" target="_blank"`;
            // End CMA links

            if (!$rootScope.cmaGBapplies) {

                $scope.acceptedRowTerms = false;

                $scope.onChangeCheckboxROW = () => {

                    $scope.acceptedRowTerms = !$scope.acceptedRowTerms;

                };


            } else {

                $scope.acceptedGbTerms1 = false;
                $scope.acceptedGbTerms2 = false;

                $scope.onChangeCheckboxGB1 = () => {

                    $scope.acceptedGbTerms1 = !$scope.acceptedGbTerms1;

                };
                $scope.onChangeCheckboxGB2 = () => {

                    $scope.acceptedGbTerms2 = !$scope.acceptedGbTerms2;

                };

            }

            if ($scope.recommendation) {

                $scope.showOcpScreen = true;
                // link to support page
                const language = (CWCONFIG.language === 'de') ? 'de' : 'en';
                $scope.supportUrl = '/dashboard/support/tabs/support';

                // reset of the world region
                $scope.paymentSupportUrlRegionCB = `https://shop.avira.com/30/?scope=cuseco&cfg=av092017_ppe&language=${language}`;
                // USA region
                $scope.paymentSupportUrlRegionCA = `https://shop.avira.com/819/?scope=cuseco&cfg=webcart_2017_tax&language=${language}`;

                /**
                 * User will be billed and renewed 1 day before the expiration of the free 30 days
                 * so we need to show him the billing date 29 days from the day he activated
                 */
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + 29); // add 29 days to current date
                $scope.trialExpirationDate = $filter('date')(currentDate);
                $scope.brandName = CWCONFIG.partnerConfig.name;
                $scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
                $scope.hrefPrivacyPolicy = CWCONFIG.partnerConfig.translationsLinks.eula.privacyPolicy.replace('{language}', CWCONFIG.language);
                $scope.hrefRightWithdrawal = CWCONFIG.partnerConfig.translationsLinks.eula.rightWithdrawal.replace('{language}', CWCONFIG.language);
                $scope.hrefSupportProductLifecycle = CWCONFIG.partnerConfig.translationsLinks.eula.supportProductLifecycle.replace('{language}', CWCONFIG.language);
                $scope.product1 = AppIntegrationsRepository.getAppName('isec0');
                $scope.product2 = AppIntegrationsRepository.getAppName('aps10');

                const languagesTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.languages;

                if (languagesTermsOfUse.find(element => element === CWCONFIG.language)) {

                    $scope.hrefTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.href.replace('{language}', CWCONFIG.language);

                } else {

                    $scope.hrefTermsOfUse = CWCONFIG.partnerConfig.translationsLinks.eula.termsOfUse.href.replace('{language}', 'en');

                }

                // get recommendation details
                $scope.recommendedProduct =
                    AppIntegrationsRepository.getById($scope.recommendation.attributes.acronym);

                // get the users payment types and use the last one
                const allPaymentTypes = PaymentTypesRepository.getAll();
                $scope.paymentInfo = allPaymentTypes[allPaymentTypes.length - 1].attributes;

                // check if the recommendation is a yearly payment subscription
                $scope.isYearlyPayment = $scope.recommendation.attributes.subscription_type === 'annual';

                $scope.activateRecommendations = () => {

                    if (!$rootScope.cmaGBapplies && !$scope.acceptedRowTerms) {

                        if (!$scope.submitted) {

                            $scope.submitted = true;

                        }
                        return;

                    }

                    if ($rootScope.cmaGBapplies &&
                        (!$scope.acceptedGbTerms1 || !$scope.acceptedGbTerms2)) {

                        if (!$scope.submitted) {

                            $scope.submitted = true;

                        }
                        return;

                    }

                    // Different error screen for cleverbrigde fail
                    const cleverbridgeErrorCodes = ['23002', '23003', '23004', '23006', '23007'];

                    $scope.showOcpScreen = false;
                    $scope.showPendingScreen = true;

                    const mixpanelDetails = {
                        Modal: 'OCP Product Details Modal',
                        'Button Label': 'Buy',
                        Product: $scope.recommendedProduct.attributes.name,
                        'Product ID': $scope.recommendedProduct.id,
                        'Recommendation ID': $scope.recommendation.id,
                        Page: Util.getPageName(),
                        Price: Util.deepFind($scope.recommendation, 'attributes.total_price_string'),
                        Discount: Util.deepFind($scope.recommendation, 'attributes.discount'),
                        Runtimes: Util.deepFind($scope.recommendation, 'attributes.runtime'),
                    };

                    Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

                    const xamedium = `${$rootScope.ocp_xa_medium}${$scope.recommendedProduct.id}`;

                    const payload = {
                        data: {
                            type: 'payments',
                            attributes: {
                                tag: 'one-click',
                            },
                            relationships: {
                                'app-recommendation': {
                                    data: {
                                        type: 'app-recommendations',
                                        id: $scope.recommendation.id,
                                    },
                                },
                            },
                        },
                        meta: {
                            'x-params': {
                                'x-a-source': 'cw',
                                'x-a-medium': xamedium,
                                'x-a-content': `${$rootScope.ocp_xa_content}${$scope.recommendedProduct.id}-${$scope.recommendation.id}`,
                                'x-a-aiatest': `${$rootScope.ocp_xa_aiatest}`,
                                'x-a-button': `${$rootScope.ocp_xa_button}`,
                            },
                        },
                    };

                    const ssoExtraParams = sessionStorage.getItem('SsoExtraUrlParams');

                    if (ssoExtraParams && ssoExtraParams.indexOf('cw_lp_paid_search') > -1) {

                        payload.meta['x-params']['x-a-campaign'] = 'cw_lp_paid_search';

                    }

                    LicensesRepository.getObservable().subscribe((data) => {

                        data.forEach((license) => {

                            const newLicenseModifyDate = new Date(Util.deepFind(license, 'attributes.modify_date'));

                            if (
                                license.relationships.app.data.id ===
                                $scope.recommendedProduct.id &&
                                modifyDate.getTime() !== newLicenseModifyDate.getTime()
                            ) {

                                clearTimeout($scope.getLicenseTimeout);
                                eventManager.broadcast('purchase completed');
                                const onMergingAppId = Util.deepFind(onMergingActivationCode, 'relationships.app.data.id');
                                $scope.onMergingApp = AppIntegrationsRepository.getById(onMergingAppId);
                                $scope.extraRuntime = Util.getExtraRuntime(license);
                                $scope.totalRuntime = Util.getRemainingRuntime(license);

                                $scope.showPendingScreen = false;
                                // check if the success modal is already displayed
                                // don't send mixpanel event twice
                                if ($scope.showSuccessScreen === true) {

                                    return;

                                }
                                $scope.showSuccessScreen = true;

                                /* update transactions repository after the pruchase has been made
                                   and get the transactions id and the invoice url for that specific purchase */
                                TransactionRestService.getAllAsync().then((response) => {

                                    TransactionsRepository.replace(response.data.data);

                                    const transactions = TransactionsRepository.getAll() || [];

                                    const currentTransaction = transactions
                                        .find(transaction => (transaction.attributes.activation_code === license.relationships['activation-code'].data.id) &&
                                        (transaction.attributes.app === license.relationships.app.data.id));
                                    $scope.transactionId = Util.deepFind(currentTransaction, 'attributes.payment_transaction_id');

                                });

                                // get activationCode after the license is received
                                ActivationCodeRestService.getAllAsync().then((response) => {

                                    ActivationCodesRepository.replace(response.data.data);

                                    $rootScope.ocpSubscriptionTooltipAppId = Util.deepFind($scope.recommendation, 'attributes.acronym');

                                });

                                // Auto deploy ISEC for all Windows devices after purchase
                                const devices = DevicesRepository.getDevicesByOs('windows') || [];

                                devices.forEach((device) => {

                                    const deploymentPayload = {
                                        deviceId: device.id,
                                        userId: Util.deepFind(device, 'relationships.user.data.id'),
                                        appId: license.relationships.app.data.id,
                                    };

                                    DeployRestService
                                        .deployOnDevice(deploymentPayload)
                                        .then(() => { })
                                        .then(null, (e) => {

                                            // 409 === Conflict
                                            // An instance for this application already exists (pending) - ignore
                                            if (e.status === 409) {

                                                return;

                                            }

                                            Alert.error({
                                                message: 'cw.modal.server-error.desc',
                                                icon: {
                                                    cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,
                                                },
                                            });

                                        });

                                });

                                $rootScope.hideSecondOfferUntilRefresh = true;

                                const mixpanelSuccess = {
                                    Source: 'OCP',
                                    Modal: 'OCP Success Modal',
                                    Product: $scope.recommendedProduct.attributes.name,
                                    'Product ID': $scope.recommendedProduct.id,
                                    'Recommendation ID': $scope.recommendation.id,
                                    'CW User ID': license.relationships.user.data.id,
                                    Page: Util.getPageName(),
                                };

                                Mixpanel.send('ConnectWeb Modal Open ', mixpanelSuccess);

                            }

                        });

                    });

                    /**
                     * Start a timeout to get the licenses if we don't receive any acp
                     * with the new licenses
                     */
                    $scope.getLicenseTimeout = setTimeout(() =>
                        LicenseRestService.getAllAsync().then((response) => {

                            LicensesRepository.replace(response.data.data);

                        }), CWCONFIG.timeouts.getLicenseTimeout);

                    PaymentsRestService.create(payload)
                        .then(() => {

                            /**
                             * Get recommendations will be empty, observable in recommendations banner
                             * will be triggered and hide the banner
                             */
                            RecommendationsRestService.getAllAsync().then((response) => {

                                RecommendationsRepository.replace(response.data.data);

                            });

                            const activationCodesPromise = ActivationCodeRestService.getAllAsync().then((response) => {

                                ActivationCodesRepository.replace(response.data.data);

                            });

                            const transactionsPromise = TransactionRestService.getAllAsync().then((response) => {

                                TransactionsRepository.replace(response.data.data);

                            });

                            if ($scope.recommendedProduct.id === 'aps10' || $scope.recommendedProduct.id === 'aps20') {

                                $rootScope.$broadcast('prime_purchase_completed');

                            }

                            const promisesArray = [activationCodesPromise, transactionsPromise];

                            Promise.allSettled(promisesArray).then(() => {

                                const activationCodes = ActivationCodesRepository.getAll();
                                const transactions = TransactionsRepository.getAll();

                                const currentTransaction = transactions.find(transaction => transaction.attributes.payment_transaction_id === $scope.transactionId);
                                const currentActivationCode = activationCodes.find(activationCode => activationCode.id === currentTransaction.relationships['activation-code'].data.id);
                                const currentRuntime = Util.deepFind(currentActivationCode, 'attributes.runtime');
                                const currentAppId = Util.deepFind(currentActivationCode, 'attributes.app');
                                const expirationDate = Util.deepFind(currentActivationCode, 'attributes.date_expire');
                                const subscriptionType = Util.deepFind(currentActivationCode, 'attributes.subscription_type');
                                $scope.formattedExpireDate = moment($scope.expireDate).format('L');

                                let nextBillingEvent = Util.deepFind(currentActivationCode, 'attributes.next_billing_event');

                                if (!nextBillingEvent) {

                                    switch (subscriptionType) {

                                    case 'yearly':
                                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                                        break;
                                    case 'monthly':
                                        nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                                        break;
                                    case 'annual':
                                        nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                                        break;
                                    case 'monthly-trial':
                                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                                        break;
                                    case 'annual-trial':
                                        nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                                        break;
                                    default:
                                        nextBillingEvent = expirationDate;

                                    }

                                }

                                $scope.nextBillingEvent = moment(nextBillingEvent).format('L');

                                $scope.currentPrice = AppPricesRepository.getSinglePrice(currentAppId, currentRuntime, '1');
                                const hasPromotion = Util.deepFind($scope.currentPrice, 'attributes.promotion');

                                if (hasPromotion) {

                                    $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.promotion.pc_price_string');

                                } else {

                                    $scope.nextBillingPrice = Util.deepFind($scope.currentPrice, 'attributes.price_string');

                                }

                            });

                        })
                        .catch((e) => {

                            $scope.showPendingScreen = false;
                            $scope.showErrorScreen = true;

                            if (e.data.errors &&
                                e.data.errors.length > 0) {

                                $scope.errorName = e.data.errors[0].statusText;

                                // cleverbridge error
                                if (e.data.errors[0].code &&
                                    cleverbridgeErrorCodes.indexOf(e.data.errors[0].code) > -1) {

                                    $scope.cleverBridgeError = true;
                                    $scope.errorCode = e.data.errors[0].code;

                                } else if (e.data.errors[0].code) {

                                    // standard error
                                    $scope.errorCode = e.data.errors[0].code;

                                } else {

                                    // standard error
                                    $scope.errorCode = e.data.errors[0].status;

                                }

                            }

                            const mixpanelSuccess = {
                                Source: 'OCP',
                                Modal: 'OCP Error Modal',
                                Product: $scope.recommendedProduct.attributes.name,
                                'Product ID': $scope.recommendedProduct.id,
                                'Recommendation ID': $scope.recommendation.id,
                                'Error Code': $scope.errorCode || null,
                                'Error Name': $scope.errorName || null,
                                Page: Util.getPageName(),
                            };

                            Mixpanel.send('ConnectWeb OCP Buy Click', mixpanelSuccess);

                        });

                };

                $scope.cancel = () => {

                    const mixpanelDetails = {
                        Modal: 'OCP Product Details Modal',
                        'Button Label': 'Cancel',
                        Product: $scope.recommendedProduct.attributes.name,
                        'Product ID': $scope.recommendedProduct.id,
                        'Recommendation ID': $scope.recommendation.id,
                        Page: Util.getPageName(),
                    };

                    Mixpanel.send('ConnectWeb Modal Button Click', mixpanelDetails);

                    Util.closeModal();

                };

                $scope.closeOCP = () => {

                    Util.closeModal();

                };
                $scope.redirectToSubscriptionPage = () => {

                    if ($scope.recommendedProduct.id === 'adwp1') {

                        $state.go('root.dashboard.dwm', {
                            tab: 'dwm',
                        });

                    } else {

                        $state.go('root.dashboard.subscriptions', {
                            tab: 'plans',
                        });

                    }

                };

            } else {

                Util.closeModal();

            }

            $scope.$on('$destroy', () => {

                $rootScope.disableCloseModalOCP = false;

            });

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/one-click-payment.js